import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Notification from '@tds/core-notification';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import RatePlanTable from './components/rateplanTable';

const RatePlans = ({
  orderType,
  productSelected,
  rateplanList,
  contentfulError,
  accountType,
  viewType,
  ratePlans,
  setRatePlans,
  total,
  setTotal,
  formErrors,
  setRatePlanError
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { ratePlanHeading }
  } = localizedStrings;
  const errorMessage = _.get(formErrors, 'iotRatePlans.text', '');

  useEffect(() => {
    if (_.isEmpty(ratePlans)) {
      const initialRateplanObject = rateplanList.reduce((planAcc, planData) => {
        const { rateplanName, rateplanType, isHeader, deviceList } = _.get(
          planData,
          'fields',
          {}
        );
        if (!isHeader) {
          const deviceListObject = deviceList.reduce(
            (deviceAcc, deviceData) => {
              const { deviceName } = _.get(deviceData, 'fields', {});
              return {
                ...deviceAcc,
                [deviceName]: {
                  term: '',
                  quantity: 0,
                  unitPrice: 0,
                  fiftyPercentInUS: false,
                  rateplanType
                }
              };
            },
            {}
          );
          return {
            ...planAcc,
            [rateplanName]: {
              ...deviceListObject
            }
          };
        }

        return planAcc;
      }, {});
      setRatePlans(initialRateplanObject);
    }
  }, []);
  return (
    <>
      {contentfulError && (
        <Notification variant="error" copy="en">
          Error fetching rateplans data from contentful
        </Notification>
      )}
      {!contentfulError && rateplanList.length > 0 && (
        <Box between={3}>
          <Heading level="h4">{ratePlanHeading}</Heading>
          <RatePlanTable
            orderType={orderType}
            productSelected={productSelected}
            accountType={accountType}
            viewType={viewType}
            ratePlans={ratePlans}
            setRatePlans={setRatePlans}
            rateplanList={rateplanList}
            total={total}
            setTotal={setTotal}
            setRatePlanError={setRatePlanError}
          />
        </Box>
      )}
      {errorMessage && (
        <Notification variant="error" copy="en">
          {errorMessage}
        </Notification>
      )}
    </>
  );
};

RatePlans.propTypes = {
  orderType: PropTypes.string.isRequired,
  productSelected: PropTypes.string.isRequired,
  rateplanList: PropTypes.objectOf(PropTypes.any).isRequired,
  contentfulError: PropTypes.objectOf(PropTypes.any).isRequired,
  accountType: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRatePlans: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({}).isRequired,
  setRatePlanError: PropTypes.func.isRequired
};

export default RatePlans;
